var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircleUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8814 31.2061C64.5032 31.2061 72.3046 39.0075 72.3046 48.6292C72.3046 58.251 64.5032 66.0524 54.8814 66.0524C45.2597 66.0524 37.4583 58.251 37.4583 48.6292C37.4583 39.0075 45.2597 31.2061 54.8814 31.2061ZM54.8814 36.407C48.1202 36.407 42.6592 41.868 42.6592 48.6292C42.6592 55.3905 48.1202 60.8514 54.8814 60.8514C61.6427 60.8514 67.3637 55.3905 67.3637 48.6292C67.3637 41.868 61.6427 36.407 54.8814 36.407Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.87 0C85.2955 0 110 24.7045 110 54.87C110 85.2955 85.2955 110 54.87 110C24.7045 110 0 85.2955 0 54.87C0 24.7045 24.7045 0 54.87 0ZM54.87 5.46099C27.565 5.46099 5.46099 27.565 5.46099 54.87C5.46099 82.1749 27.565 104.279 54.87 104.279C82.1749 104.279 104.279 82.1749 104.279 54.87C104.279 27.565 82.1749 5.46099 54.87 5.46099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3351 67.8725H68.38C77.2216 67.8725 84.2429 74.8938 84.5029 83.4753L79.562 87.8961V83.9954C79.562 78.0143 74.6211 73.0734 68.38 73.0734H41.3351C35.354 73.0734 30.4131 78.0143 30.4131 83.9954V87.8961L25.2122 83.4753C25.7323 74.8938 32.7535 67.8725 41.3351 67.8725Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CircleUser.2535b788.svg";
export { ForwardRef as ReactComponent };